import { render, staticRenderFns } from "./Bought.vue?vue&type=template&id=04a64266&"
import script from "./Bought.vue?vue&type=script&lang=js&"
export * from "./Bought.vue?vue&type=script&lang=js&"
import style0 from "./Bought.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QPopupProxy,QDate,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QPopupProxy,QDate,QTable,QTr,QTh,QTd})
